import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  createGroupPayload: {}
}

export const createProjectSlice = createSlice({
  name: 'createProject',
  initialState,
  reducers: {
    setCreateGroupPayload: (state, action) => {
      state.createGroupPayload = action.payload
    },
    resetCreateGroupPayload: (state) => {
      state.createGroupPayload = {}
    },
    resetCreateProject: () => initialState
  }
})

export const {setCreateGroupPayload, resetCreateGroupPayload, resetCreateProject} = createProjectSlice.actions

// Selectors
export const selectCreateGroupPayload = (state) => state.createProject.createGroupPayload

export default createProjectSlice.reducer
